export var AuthCookie;
(function (AuthCookie) {
    AuthCookie["AUTH_TOKEN"] = "auth_token";
})(AuthCookie || (AuthCookie = {}));
export function parseCookies() {
    const cookies = document.cookie.split(';');
    const cookieObj = {};
    for (const cookie of cookies) {
        const [key, value] = cookie.split('=').map((c) => c.trim());
        cookieObj[key] = value;
    }
    return cookieObj;
}
export function getCookieValue(name) {
    const cookies = parseCookies();
    return cookies[name];
}
export function setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/;`;
}
